import { render, staticRenderFns } from "./SingleTextarea.vue?vue&type=template&id=521c2642"
import script from "./SingleTextarea.vue?vue&type=script&lang=js"
export * from "./SingleTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports